import { Component, Output, EventEmitter, ChangeDetectorRef, NgZone, Renderer2, Input, ViewRef, AfterViewInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LpsConversionDetails } from 'src/app/models/lps-conversion-details';
import { CommonUtils } from 'src/app/utils/common-utils';

@Component({
  selector: 'advanced-options-panel',
  templateUrl: './advanced-options-panel.component.html',
  styleUrls: ['./advanced-options-panel.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvancedOptionsPanelComponent implements AfterViewInit, OnDestroy {

  @Output() validationEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() conversionDetailsChange: EventEmitter<LpsConversionDetails> = new EventEmitter<LpsConversionDetails>();

  private _fields: LpsConversionDetails;
  private advOptionsChangeSubscription: Subscription;
  private spectrumInstanceTypeChangeSubscription: Subscription;

  @Input('conversionDetails') 
  public get fields(): LpsConversionDetails { return this._fields; }
  public set fields(value: LpsConversionDetails) {
    if (this.advOptionsChangeSubscription) { this.advOptionsChangeSubscription.unsubscribe(); }
    this._fields = value;
    if (this._fields) {
      this.advOptionsChangeSubscription = this._fields.advancedOptionsChange.subscribe(() => { 
        this.conversionDetailsChange.emit(this.fields);
        this.validateFields();
        this.detectChanges(); });
      this.spectrumInstanceTypeChangeSubscription = this._fields.spectrumInstanceTypeChange.subscribe(value => { 
        if (value === 'Cloud') {
          this.fields.imagesParentName = undefined;
          this.fields.layoutsParentName = undefined;
          this.fields.dataServicesParentName = undefined;
          this.detectChanges();
        } else {
          this.fields.imagesParentName = '0/Images/User Images';
          this.fields.layoutsParentName = '0/Layouts';
          this.fields.dataServicesParentName = '0/DataServices';
          this.detectChanges();
        }
      })
    }
    this.detectChanges();
  }

  constructor(private cdr: ChangeDetectorRef, private ngZone: NgZone, private renderer: Renderer2) { }

  public ngAfterViewInit(): void {
    if (this.fields === undefined) { 
      this.fields = new LpsConversionDetails(); 
      this.conversionDetailsChange.emit(this.fields);
    }
    if (this.fields && !(this.fields.advancedFieldsInitialized)) {
      this.fields.initializeAdvancedFields();
    }
  }
  
  public ngOnDestroy(): void {
    if (this.advOptionsChangeSubscription) { this.advOptionsChangeSubscription.unsubscribe(); }
    if (this.spectrumInstanceTypeChangeSubscription) { this.spectrumInstanceTypeChangeSubscription.unsubscribe(); }
  }
  
  protected isTouched(field: HTMLElement) { return field !== undefined && field.classList.contains('ng-touched'); }

  protected validateFields() {
    const isValid = this.fields ? this.fields.validateAdvancedOptionFields() : false;
    this.validationEvent.emit(isValid);
  }

  protected detectChanges(delay: boolean = false) { 
      if (delay === true) {
        CommonUtils.lwDelay(this, this.ngZone, () => { this.detectChanges(); })
      } else {
        if (this.cdr && !((this.cdr as ViewRef).destroyed)) { this.cdr.detectChanges(); }
      }
    }
}